import User from "../../components/User/User";
import { sellerSubRoles } from "../../config/ROLES";

export default function SellerUser() {

  return (
    <User subRoles={sellerSubRoles} />
  );
}